function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

/**
 * Dropdown with a few defaults to save a couple of copy pasted lines here and there.
 * 
 * @param {Array} options - Array of the form [{ key: string, value: string, text: string }] OR Array of strings
 * @returns 
 */
export default function Dropdown(_ref) {
  let {
    name,
    value,
    onChange,
    options,
    showNullOption = true,
    passEntireEvent = false,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation();
  let dropDownOptions = options;
  if (typeof options[0] === 'string') {
    dropDownOptions = options.map(o => ({
      key: o,
      value: o,
      text: o
    }));
  }
  return /*#__PURE__*/React.createElement(Form.Control, _extends({
    as: "select",
    name: name,
    value: value,
    onChange: e => onChange(passEntireEvent ? e : e.target.value),
    size: "md",
    type: "text"
  }, props), showNullOption && /*#__PURE__*/React.createElement("option", {
    value: null
  }), dropDownOptions.map(o => /*#__PURE__*/React.createElement("option", {
    value: o.value,
    key: o.key
  }, t(o.text))));
}